import {
  type reverb_search_Filter as Filter,
  type reverb_search_FilterOption as FilterOption,
  reverb_search_Filter_WidgetType as WidgetType,
} from '../rql';

export { type Filter, type FilterOption, WidgetType };

interface ITextFilterOptions {
  paramName: string;
  paramValue: string;
  name?: string;
  widgetType?: WidgetType;
}
export function textFilter(options: ITextFilterOptions): Filter {
  const { paramName, paramValue, name, widgetType } = options;

  const hasValue = !!paramValue;

  return {
    name,
    widgetType: widgetType || WidgetType.TEXT,
    options: [
      {
        paramName,
        name: `"${paramValue || ''}"`,
        selected: hasValue,
        setValues: [paramValue],
        all: false,
      },
    ],
  };
}

export function getRangeValue(filter: Filter, side: 'min' | 'max') {
  const sideIdx = side === 'min' ? 0 : 1;
  const param = filter.options[sideIdx];

  return {
    key: param.paramName,
    value: param.setValues[0],
  };
}

export function getRangeUnsetParams(filter: Filter) {
  const minSide = filter.options[0];
  const maxSide = filter.options[1];

  return {
    [minSide.paramName]: minSide.unsetValues,
    [maxSide.paramName]: maxSide.unsetValues,
  };
}
